import { A } from '@solidjs/router';
import { createEffect, createSignal, For, onCleanup, Show } from 'solid-js';
import PublicLayout from '../PublicLayout';

const POSTS = [
  {
    slug: 'crystal-ball',
    title:
      'Quả Cầu Pha Lê Kho Hàng: Dùng AI Dự Đoán Nhu Cầu Trước Khi Nó Xảy Ra',
    description:
      'Chán cảnh hết hàng bestseller trong khi hàng chậm chất đống? Tìm hiểu cách AI tính tốc độ bán hàng theo từng SKU, đưa ra dự báo kèm điểm tin cậy, và tự động chuyển đổi dự báo thành đơn đặt hàng nhà cung cấp.',
    date: '9 tháng 5, 2026',
    readTime: '9 phút đọc',
    category: 'AI & Dự Báo',
    image: '/blog-forecast-hero.jpg',
  },
  {
    slug: 'growth-trap',
    title:
      'Bẫy Tăng Trưởng: Vì Sao Hệ Thống Thủ Công Của Bạn Sẽ Sụp Đổ Ở Mức 50 Đơn Hàng Mỗi Ngày',
    description:
      'Điều hoạt động tốt với 5 đơn hàng mỗi ngày sẽ trở thành cơn ác mộng ở mức 50. Tìm hiểu về "nợ kỹ thuật" trong kho hàng, quét mã vạch, và kiểm tra áp lực 60 giây để biết bạn có sẵn sàng mở rộng quy mô hay không.',
    date: '8 tháng 5, 2026',
    readTime: '8 phút đọc',
    category: 'Chiến lược vận hành',
    image: '/blog-scaling-chaos.jpg',
  },
  {
    slug: 'ghost-inventory',
    title: 'Bóng Ma Trong Hệ Thống: Xóa Bỏ Hàng Tồn Ảo Và Hàng Chết',
    description:
      'Hàng tồn ảo và hàng tồn kho chết là những kẻ giết lợi nhuận thầm lặng. Tìm hiểu cách kiểm kê vòng, điểm đặt hàng tối ưu, theo dõi lô FIFO và đồng bộ thời gian thực giúp loại bỏ chúng.',
    date: '6 tháng 5, 2026',
    readTime: '9 phút đọc',
    category: 'Kiểm soát tồn kho',
    image: '/blog-ghost-inventory.jpg',
  },
  {
    slug: 'walking-tax',
    title:
      'Thuế Di Chuyển: Cách Bố Cục Kho Hàng Đang Âm Thầm Bào Mòn Chi Phí Nhân Công',
    description:
      'Trong một kho hàng chưa được tối ưu, một nhân viên có thể đi hơn 15 km mỗi ca. Tìm hiểu cách velocity slotting và zone picking cắt giảm 20% khoảng cách di chuyển — tương đương một nhân viên miễn phí.',
    date: '6 tháng 5, 2026',
    readTime: '8 phút đọc',
    category: 'Hiệu quả lao động',
    image: '/blog-walking-tax-tired-worker.jpg',
  },
  {
    slug: 'spreadsheet-trap',
    title:
      'Bẫy Bảng Tính: Hệ Thống Tồn Kho Của Bạn Đang Tiêu Tốn Bao Nhiêu Tiền?',
    description:
      'Hàng tồn ảo, phân mảnh dữ liệu và không có khả năng giám sát thời gian thực — chi phí ẩn khi vận hành kho hàng bằng bảng tính, và cách các nền tảng hiện đại loại bỏ chúng.',
    date: '6 tháng 5, 2026',
    readTime: '7 phút đọc',
    category: 'Vận hành',
    image: '/blog-spreadsheet-trap-hero.jpg',
  },
];

const PAGE_SIZE = 3;

export default function BlogsIndexPageVi() {
  createEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'Blog',
      name: 'Khoai Blog',
      description:
        'Kiến thức về quản lý tồn kho, vận hành kho hàng và tự động hóa logistics từ đội ngũ Khoai.',
      url: 'https://khoai.io/vi/blogs',
      publisher: {
        '@type': 'Organization',
        name: 'khoai.io',
        url: 'https://khoai.io',
      },
    };

    let script = document.getElementById(
      'ld-json-blogs-index-vi'
    ) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'ld-json-blogs-index-vi';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);

    let listScript = document.getElementById(
      'ld-json-blogs-index-vi-list'
    ) as HTMLScriptElement | null;
    if (!listScript) {
      listScript = document.createElement('script');
      listScript.type = 'application/ld+json';
      listScript.id = 'ld-json-blogs-index-vi-list';
      document.head.appendChild(listScript);
    }
    listScript.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: 'Khoai Blog — Bài Viết',
      url: 'https://khoai.io/vi/blogs',
      itemListElement: POSTS.map((post, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        name: post.title,
        url: `https://khoai.io/vi/blogs/${post.slug}`,
      })),
    });
  });

  onCleanup(() => {
    document.getElementById('ld-json-blogs-index-vi')?.remove();
    document.getElementById('ld-json-blogs-index-vi-list')?.remove();
  });

  const [page, setPage] = createSignal(0);
  const totalPages = () => Math.ceil(POSTS.length / PAGE_SIZE);
  const pagePosts = () =>
    POSTS.slice(page() * PAGE_SIZE, page() * PAGE_SIZE + PAGE_SIZE);

  return (
    <PublicLayout>
      <div class="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
        {/* Page header */}
        <header class="mb-12 text-center">
          <p class="text-sm font-semibold uppercase tracking-widest text-amber-600">
            Khoai Blog
          </p>
          <h1 class="mt-2 text-4xl font-extrabold text-gray-900 sm:text-5xl">
            Kiến Thức Cho Người Quản Lý Kho
          </h1>
          <p class="mx-auto mt-4 max-w-2xl text-lg text-gray-500">
            Bài viết thực tiễn về quản lý tồn kho, tự động hóa logistics và xây
            dựng vận hành mở rộng được — từ đội ngũ đứng sau Khoai.
          </p>
        </header>

        {/* Post list */}
        <div class="space-y-10">
          <For each={pagePosts()}>
            {(post) => (
              <article class="group flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm transition hover:shadow-md sm:flex-row">
                {/* Thumbnail */}
                <div class="shrink-0 sm:w-64">
                  <img
                    src={post.image}
                    alt={post.title}
                    class="h-52 w-full object-cover sm:h-full"
                    loading="lazy"
                  />
                </div>

                {/* Content */}
                <div class="flex flex-col justify-between p-6">
                  <div>
                    <div class="flex items-center gap-3">
                      <span class="rounded-full bg-amber-100 px-3 py-0.5 text-xs font-semibold text-amber-700">
                        {post.category}
                      </span>
                      <span class="text-xs text-gray-400">{post.readTime}</span>
                    </div>
                    <h2 class="mt-3 text-xl font-bold text-gray-900 group-hover:text-amber-700 sm:text-2xl">
                      <A href={`/vi/blogs/${post.slug}`}>{post.title}</A>
                    </h2>
                    <p class="mt-2 text-sm leading-relaxed text-gray-500">
                      {post.description}
                    </p>
                  </div>
                  <div class="mt-5 flex items-center justify-between">
                    <span class="text-xs text-gray-400">{post.date}</span>
                    <A
                      href={`/vi/blogs/${post.slug}`}
                      class="rounded-lg bg-amber-600 px-4 py-2 text-sm font-semibold text-white hover:bg-amber-700"
                    >
                      Đọc bài viết →
                    </A>
                  </div>
                </div>
              </article>
            )}
          </For>
        </div>

        {/* Pagination */}
        <Show when={totalPages() > 1}>
          <nav
            class="mt-10 flex items-center justify-center gap-4"
            aria-label="Phân trang blog"
          >
            <button
              disabled={page() === 0}
              onClick={() => {
                setPage((p) => p - 1);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
            >
              ← Trước
            </button>
            <span class="text-sm text-gray-500">
              Trang {page() + 1} / {totalPages()}
            </span>
            <button
              disabled={page() === totalPages() - 1}
              onClick={() => {
                setPage((p) => p + 1);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
            >
              Tiếp →
            </button>
          </nav>
        </Show>

        {/* Breadcrumb back */}
        <div class="mt-16 border-t border-gray-200 pt-8 text-center">
          <A
            href="/"
            class="text-sm font-semibold text-amber-600 hover:text-amber-700"
          >
            ← Trang chủ Khoai
          </A>
        </div>
      </div>
    </PublicLayout>
  );
}
